<template>
  <router-view />  <!-- 必须有，用于渲染子路由 -->
</template>

<script>
export default {
  name: 'BlankLayout'
}
</script>